<template lang="pug">
  form.klaviyo-form(
    :class="embedClass"
    method='GET'
    accept-charset='UTF-8'
    @submit.prevent='submit'
  )
    input(type='hidden' name='form_type' value='customer')
    input(type='hidden' name='g' :value='listId')
    div( v-if="!isSuccess" )
      input(
        id="email_signup"
        label="Email Address"
        required
        type="email"
        v-model="currentValue"
        name="email"
        :placeholder="placeholder"
        :class="inputClasses"
        class="input text-input--email-capture"
        email-capture
      )
      checkbox-input( ref="consentCheckbox" )
        |By signing up, you are accepting our!{' '}
        a( href="https://www.generalmills.com/privacy-security/us-english-privacy-policy" target="_blank" ) Privacy Policy
        |!{' '}and agreeing that your information may be used across our!{' '}
        a( href="https://www.generalmills.com/food-we-make/brands" target="_blank" ) family of brands
        |.
      .form-input__error-message(
        v-if="valueIsErroneous"
        role="alert"
      ) {{ errorMessage }}
    transition(name="slideIn")
      .form-input__success-message(
        v-if="isSuccess && message" role="alert" v-html="message")
    v-button(v-if="notSubmitted" class="btn--primary" label="subscribe" type="submit")
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue';
  import VButton from 'scripts/components/buttons/VButton.vue';
  import CheckboxInput from 'scripts/components/forms/CheckboxInput.vue';

  export default {
    name: 'KlaviyoForm',
    components: {
      TextInput,
      VButton,
      CheckboxInput,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      message: String,
      listId: String,
      placeholder: String,
      redirect: String,
    },
    data() {
      return {
        isSuccess: false,
        isError: false,
        isValid: true,
        notSubmitted: true,
        currentValue: '',
        valueIsErroneous: false,
        errorMessage: "You must enter a valid email."
      };
    },
    computed: {
      embedClass() {
        return `klaviyo_embed_${this.listId}`;
      },
      inputClasses() {
        return {
          'text-input--error': this.valueIsErroneous,
          'text-input--disabled': this.disabled,
          'text-input--email-capture': this.emailCapture,
        };
      },
    },
    watch: {
      currentValue() {
        this.validate();
      },
    },
    mounted() {
      /*const klaviyoInterval = setInterval(() => {
        // eslint-disable-next-line no-undef
        if (KlaviyoSubscribe) {
          clearInterval(klaviyoInterval);

          // eslint-disable-next-line no-undef
          KlaviyoSubscribe.attachToForms(this.$el, {
            hide_form_on_success: false,
          });
        }
      }, 500);*/
    },
    methods: {
      submit() {
        this.validate();
        if (this.isValid && !this.$refs.consentCheckbox.isChecked) {
          this.isValid = false;
          this.errorMessage = "To sign up, you must check the box above";
          this.valueIsErroneous = true;
          this.onError();
        }

        if (!this.isValid)
          return;
        this.notSubmitted = false;

        fetch(
          `https://apigeex2.juicyorange.com/${window.profileSiteKey}/register`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: this.currentValue, subscribe: 'true', consent: 'true' })
          }
        ).then(response => response.json()).then(data => {
          document.cookie = "gmi.profile.id=" + data.UserId + "; path=/; secure=true";
          document.cookie = "gmi.profile.unified.id=" + data.UnifiedId + "; path=/; secure=true";
          document.cookie = "gmi.profile.status=EmailOnly; path=/; secure=true";
          this.notSubmitted = !data;
          this.isSuccess = data;
          if (this.redirect)
            window.location = this.redirect;
        })/*.catch(() => {
          this.notSubmitted = true;
          this.isSuccess = false;
        })*/;
      },
      validate() {
        this.isValid = !!this.currentValue;

        if (this.currentValue) {
          const emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
          this.isValid = this.currentValue.match(emailPattern) !== null;
        }

        if (this.currentValue && this.pattern) {
          let validationPattern = this.pattern;

          if (validationPattern[0] === '/') validationPattern = validationPattern.slice(1);
          if (validationPattern[validationPattern.length - 1] === '/') validationPattern = validationPattern.slice(0, -1);

          validationPattern = new RegExp(validationPattern);
          this.isValid = this.currentValue.match(validationPattern) !== null;
        }
        if (!this.isValid)
          this.errorMessage = "You must enter a valid email.";

        this.valueIsErroneous = !this.isValid;
        this.valueIsErroneous ? this.onError() : '';
      },
      onError() {
        this.isError = true;
      },
    },
  };
</script>

<style scoped lang="scss">
  .klaviyo-form .btn--primary {
    margin: rem(24px) 0 0 0;
  }

  .klaviyo-form .message--success {
    color: $color-utility-success;
    margin: rem(16px) 0;
  }

  .form-input:placeholder {
    color: var(--color-grey-500);
  }
</style>
